<template>
  <panel no-button="true" title="List of Users">
    <router-link class="btn btn-secondary btn-yellow" :to="addUserPath">
      Add User
    </router-link>

    <table class="table">
      <thead>
        <th>Username</th>
        <th>Role</th>
        <th colspan="2">Created</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            {{ item.username }}
          </td>
          <td>
            {{ item.role }}
          </td>
          <td>
            {{ item.createdAt | date }}
          </td>

          <td class="with-btn-group">
            <b-button
              variant="link"
              class="text-black"
              :to="{ name: 'user', params: { id: item.id } }"
            >
              Edit
            </b-button>
            <b-button
              variant="link"
              class="text-black"
              @click="confirmDelete(item)"
            >
              Delete
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <delete-modal
      v-if="selectedForDelete"
      id="confirmUserDeleteModal"
      :on-confirm="deleteItem"
    >
      <template slot="content">
        User {{ selectedForDelete.username }} will be deleted permanently. Are
        you sure?
      </template>
    </delete-modal>
  </panel>
</template>

<script>
import { mapActions } from 'vuex'
import DeleteModal from '../../components/shared/DeleteModal.vue'
import UserMixin from '../../mixins/UserMixin'
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    selectedForDelete: null
  }),
  components: {
    DeleteModal
  },
  mixins: [UserMixin],
  filters: {
    date: function (value) {
      if (!value) return ''
      return new Date(value).toLocaleDateString()
    }
  },
  computed: {
    addUserPath() {
      if (this.isSystemAdmin) {
        if (this.$route.name === 'company') {
          return '/user/create?c=' + this.$route.params.id
        }
        return '/'
      }
      return '/user/create'
    }
  },
  methods: {
    ...mapActions('user', ['deleteUser']),
    confirmDelete(item) {
      this.$bvModal.show('confirmUserDeleteModal')
      this.selectedForDelete = item
    },
    deleteItem() {
      this.deleteUser(this.selectedForDelete.id)
      this.$router.go()
    }
  }
}
</script>
